var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-grow text-dark",style:(_vm.spinnerStyle),attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }